define('commons/ethernet-connectivity-new-edit',['jquery'], function($) {
    
    var EthernetConnectivityNewEdit = function(typeSelector, options){

        this.settings = {
            ipId : '#ip-field',
            maskId : '#mask-field',
            dns1Id : '#dns1-field',
            dns2Id : '#dns2-field',
            gatewayId : '#gateway-field',
            mtuId : '#mtu-field',
            mtuLabel : '#mtu-label',
            vlanId : '#vlan-field'
        }

        this.typeSelector = typeSelector;
        $.extend(this.settings, options);
        
        this.ipField = $(this.settings.ipId);
        this.maskField = $(this.settings.maskId);
        this.dns1Field = $(this.settings.dns1Id);
        this.dns2Field = $(this.settings.dns2Id);
        this.gatewayField = $(this.settings.gatewayId);
        this.mtuField = $(this.settings.mtuId);
        this.mtuLabel = $(this.settings.mtuLabel);
        this.vlanField = $(this.settings.vlanId);
        var me = this;
        $(typeSelector).change(function(event) {
            me.changeEthType();
        })

        this.changeEthType();
    };

    EthernetConnectivityNewEdit.prototype.changeEthType = function() {
        var isStatic = $(this.typeSelector).val() == "STATIC";
        var isPartlyDynamic = $(this.typeSelector).val() == "PARTLY_DYNAMIC";
        if (isStatic) {
            this.ipField.show();
            this.maskField.show();
            this.dns1Field.show();
            this.dns2Field.show();
            this.gatewayField.show();
            this.mtuLabel.html("MTU")
        } else {
            this.ipField.hide();
            this.maskField.hide();
            this.dns1Field.hide();
            this.dns2Field.hide();
            this.gatewayField.hide();
            this.mtuLabel.html("MTU*")
        }
        if (isStatic || isPartlyDynamic) {
            this.mtuField.show();
            this.vlanField.show();
        } else {
            this.mtuField.hide();
            this.vlanField.hide();
        }
    };

    return EthernetConnectivityNewEdit;
});
